function buildDropdown() {
	var items = [];

	$('.ajaxcart__product').each(function () {
		// Remove everything after ' - ' in the displayable product name.
		// Intended to remove color variant names from product names.
		var splitString = $(this).find('.ajaxcart__product-name-orig').html().trim().split(' - ');

		items.push({
			line: $(this).find('.ajaxcart__row').data('line'),
			productUrl: $(this).find('.ajaxcart__product-image').attr('href'),
			imageUrl: $(this).find('.ajaxcart__product-image img').attr('src'),
			name: splitString[0],
			size: $(this).find('.ajaxcart__product-variant-size').html().trim(),
			color: splitString[1]
		});

		$(this).find('.ajaxcart__product-name').text(splitString[0]);
	});

	// If bag does not contain any items
	if (items.length == 0) {
		$('#bag-dropdown-notification-banner').addClass('active');
	}

	var itemContainer = $('#bag-dropdown-items .cart');
	itemContainer.empty();

	var itemCounter = 0

	if (items.length === 0) {
		$('#bag-dropdown-notification-banner').addClass('active');
	}

	items.forEach(function (item) {
		itemCounter = itemCounter + 1;

		var itemRow = $('<div></div>');
		itemRow.attr('class', 'bag-dropdown-item-row');

		var closeIcon = $('<span></span>');
		closeIcon.attr('class', 'icon icon-x');

		var productLink = $('<a></a>');
		productLink.attr('class', 'bag-dropdown-item-link');
		productLink.attr('href', item.productUrl);

		var image = $('<img/>');
		image.attr('class', 'bag-dropdown-item-image');
		image.attr('src', item.imageUrl);

		var title = $('<p>' + item.name + '</p>');
		title.attr('class', 'bag-dropdown-item-title');

		if ('undefined' !== typeof item.size && item.size.length > 0) {
			var size = $('<p>Size: ' + item.size + '</p>');
			size.attr('class', 'bag-dropdown-item-size');
		}

		if ('undefined' !== typeof item.color && item.color.length > 0) {
			var color = $('<p>Colour: ' + item.color + '</p>');
			color.attr('class', 'bag-dropdown-item-color');
		}

		var removeLink = $('<a href="/cart/change?line=' + itemCounter + '&amp;quantity=0" style="display: block; font-size: 9px">REMOVE</a>');
		removeLink.attr('class', 'bag-dropdown-item-remove-link');

		productLink.append(image);
		itemRow.append(productLink);
		itemRow.append(title);
		itemRow.append(size);
		itemRow.append(color);
		itemRow.append(removeLink);
		itemContainer.append(itemRow);

		var notifyBarEnabled = $('#notification-bar').length > 0 ? true : false;
		var currentCurrency = currencies[$.cookie('cart_currency')];
		
		if (!currentCurrency) {
			currentCurrency = currencies[activeCurrency];
		}

		$.get('/cart.js', function (cart) {
			$('.bag-dropdown-subtotal .subtotal').text(Shopify.formatMoney(cart.total_price, currentCurrency + '{{amount}}'));
			$('.cart-subtotal .price').text(Shopify.formatMoney(cart.total_price, currentCurrency + '{{amount}}'));

			if (notifyBarEnabled && 'undefined' !== typeof appserverConfig) {
				var threshold = appserverConfig.FreeShippingAmount * 100;
				var freeShippingEnabled = appserverConfig.Options.FreeShippingEnabled;

				if (!freeShippingEnabled || threshold < cart.total_price) {
					// Bag dropdown
					$('#bag-dropdown-notification-banner').removeClass('active');
					$('#bag-dropdown-container').removeClass('notification-bar-enabled');

					// Cart page
					$('.cart-notification-bar').removeClass('active');
				} else {
					// Bag dropdown
					$('#bag-dropdown-notification-banner').addClass('active');
					$('#bag-dropdown-container').addClass('notification-bar-enabled');

					// Cart page
					$('.cart-notification-bar').addClass('active');
				}
			}
		}, 'json');

	});

	return true;

}

$('body').on('ajaxCart.afterCartLoad', function () {
	buildDropdown();
});

$(document).on('ready', function () {
	ajaxCart.load();
});